import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { FC } from "react";
import { PASSWORD_RULES } from "utils/password";

interface Props {
  /** Current value of the new-password field. */
  value?: string;
  style?: React.CSSProperties;
}

/**
 * Live checklist of the password policy. Each rule flips to a green check the
 * moment the typed value satisfies it, otherwise it shows a red cross. Purely
 * presentational — the same rules are enforced by `passwordRule`/the backend,
 * so this only mirrors the actual submit gate.
 */
const PasswordRequirements: FC<Props> = ({ value = "", style }) => {
  return (
    <ul
      aria-live="polite"
      style={{
        listStyle: "none",
        margin: 0,
        padding: 0,
        display: "flex",
        flexWrap: "wrap",
        gap: "4px 16px",
        ...style,
      }}
    >
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(value);
        return (
          <li
            key={rule.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 12,
              transition: "color 0.2s",
              color: met ? "#52c41a" : "#ff4d4f",
            }}
          >
            {met ? (
              <CheckCircleFilled aria-hidden style={{ fontSize: 13 }} />
            ) : (
              <CloseCircleFilled aria-hidden style={{ fontSize: 13 }} />
            )}
            <span>{rule.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirements;
